module.exports = __webpack_public_path__ + "img/發.fe349e9d.png";